/**
 * Shuffle `items` in place (Fisher–Yates) and return the same array.
 *
 * Every order is equally likely. `items.sort(() => Math.random() - 0.5)` is not a substitute: a
 * comparator that answers at random leaves some orders far likelier than others, and how skewed
 * depends on the engine's sort. Copy first (`shuffleInPlace([...items])`) to keep the original.
 */
export function shuffleInPlace<T>(items: T[]): T[] {
  for (let i = items.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [items[i], items[j]] = [items[j], items[i]];
  }
  return items;
}
